export default __webpack_public_path__ + "static/media/4.d8504fc5.svg";